"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EPaymentMethod_1 = require("../../../../enums/ProductSubscribed/EPaymentMethod");
const EAutreCgpCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EAutreCgpCorporationGroups");
const EConnaissanceExperienceCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EConnaissanceExperienceCorporationGroups");
const EPatrimoineRevenusCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EPatrimoineRevenusCorporationGroups");
const ETestAdequationCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/ETestAdequationCorporationGroups");
const ESubFilesTypes_1 = require("../../../../enums/Subscription/File/ESubFilesTypes");
const GenericCorporationProduct_1 = require("../GenericCorporationProduct");
const product = {
    payment_methods: {
        groups: [EPaymentMethod_1.EPaymentMethod.VIREMENT],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.payment_methods.validationClass,
    },
    patrimoine_revenus: {
        groups: [
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.beneficieConventionsFiscalesCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.secteurActiviteCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.situationFinanciereCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.patrimoineCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.compositionPatrimoineCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.situationFinancierePermetPlacerCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.partInvestissementPatrimoineGlobalCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.categorisationMifCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.societeUsPersonCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.statutFactaCrsCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.patrimoine_revenus.validationClass,
    },
    connaissance_experience: {
        groups: [
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.supportPlacementConnaissezCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.supportPlacementPossedezCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.modeGestionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.experienceProfessionnelleCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.frequenceTransactionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.moyenneTransactionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.connaissancesMarcheFinancierProduitsEpargneCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.risqueRendementCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.connaissance_experience.validationClass,
    },
    test_adequation: {
        groups: [
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.horizonInvestissementCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.informationModifierSituationFinanciereCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.avantagesRisquesSCPICorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.accepterPlacementLongTermeCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.accepterNonGarantieCapitalCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.accepterRendementNonGarantiCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.test_adequation.validationClass,
    },
    finance_durable: GenericCorporationProduct_1.GenericCorporationProduct.finance_durable,
    autre_cgp: {
        groups: [
            EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.modeEntreeRelationCorporation,
            EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.dateEntreeRelationCorporation,
            EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationClientCorporation,
            EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationOperationCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.autre_cgp.validationClass,
    },
    files: {
        groups: [
            ESubFilesTypes_1.ESubFilesTypes.RIB_CORPORATION,
            ESubFilesTypes_1.ESubFilesTypes.KBIS,
            ESubFilesTypes_1.ESubFilesTypes.CERTIFIED_STATUS,
            ESubFilesTypes_1.ESubFilesTypes.CARD_ID_LEGAL_REPRESENTATIVE,
            ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_DOMICILE_LEGAL_REPRESENTATIVE,
            ESubFilesTypes_1.ESubFilesTypes.BENEFICIARIES_LIST,
            ESubFilesTypes_1.ESubFilesTypes.BENEFICIARIES_ID,
            ESubFilesTypes_1.ESubFilesTypes.BENEFICIARIES_JUSTIFICATIF_DOMICILE,
            ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_ORIGINE_FONDS_CORPORATION,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.files.validationClass,
    },
};
exports.default = product;
